import _const from "../types";

const initialState = {
  supportedNetworks: [],
  gettingNetworks: false,
};

const networksReducers = (state = initialState, action) => {
  switch (action.type) {
    case _const.SET_NETWORKS:
      return {
        ...state,
        supportedNetworks: action.payload,
      };
    case _const.SET_GETTING_NETWORKS:
      return {
        ...state,
        gettingNetworks: action.payload,
      };
    default:
      return state;
  }
};

export default networksReducers;
